/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
import { showOverlayAds } from 'utils/ads';
// import Structure from 'components/shared/structure/structure_container';
import Frame from 'components/frames/frame_container';
import Footer from 'components/shared/footer/footer_container';
import Skip from 'components/shared/skip/skip_container';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/content/ad/ad_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ AD : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Ad extends Component {
    constructor(props) {
        super(props);
    }
    componentWillMount() {
        this.setTotalFrameCount();
    }
    componentWillReceiveProps(nextProps) {
        // when content is active show overlay
        if (!this.isActiveContent() && this.isActiveContent(nextProps)) { // component will reactivate
            this.setTotalFrameCount();
            showOverlayAds(true);
        }
        // when content is inactive remove overlay
        if (this.isActiveContent() && !this.isActiveContent(nextProps)) { // component will reactivate
            showOverlayAds(false);
        }
    }
    createFrames() {
        return <Frame id={null} type={'ad'} frameIndex={0} contentId={this.props.contentId} markup={``} />;
    }
    isActiveContent(props = this.props) {
        return props.currentContentStatus['status'] === 'active';
    }
    isOverlayAd(props) {
        // needed because if this content is an overlay ad, but it should only show on desktop or mobile, we can't have it showing on the other device or it would overlay with just a background, no ad, and interupt the flow
        return ((props.currentContentStatus['type'] === 'ad') && (props.embedSettings.ads.display[props.sessionStatus.device].includes('OVERLAY'))) ? true : false;
    }
    // check if we ACTUALLY need the overlay ad
    // we may have a case where we have an overlay for desktop and not mobile, or vice versa
    setTotalFrameCount() {
        if (!this.isOverlayAd(this.props)){
            this.props.setTotalFrameCount(this.props.contentId, 0); // set to zero to deactivate self and move to next frame
        } else {
            this.props.setTotalFrameCount(this.props.contentId, 1); // set to 1 so we stay on frame and use settings properly
        }
    }
    render() {
        if (!this.isActiveContent()) { return null; }
        // <Structure contentId={this.props.contentId} markup={this.createFrames()} />
        return(
            <div className={`${sheet.classes.uniquecontent} uniquecontent ${this.props.currentContentStatus['type']}`}>
                {this.createFrames()}
                {this.props.cookieCheckDone &&
                    <Footer contentId={this.props.contentId}>
                        <Skip contentId={this.props.contentId}/>
                    </Footer>}
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Ad;
